// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"c216cb70","188":"617a3123","744":"a76ac748","911":"5661c2f7"}[chunkId] + ".chunk.css";
};